import IconButton, { customIconButtonProps } from '../IconButton/IconButton';

export type IconButtonsStackProps = customIconButtonProps;

const IconButtonsStack = ({ iconButtons }: any) => {
  return (
    <>
      {iconButtons.map((button: IconButtonsStackProps, i: number) => {
        return (
          <div key={i} className="mx-4">
            <IconButton
              className={button.className}
              variant={button.variant}
              icon={button.icon}
              size={button.size}
              tooltipText={button.tooltipText}
              link={button.link}
              target={button.target}
              isStatusButton={button.isStatusButton}
              extLabel={button.extLabel}
            />
          </div>
        );
      })}
    </>
  );
};

export default IconButtonsStack;
